import { useSearchParams } from 'react-router-dom';

export const useCoachCredential = () => {
  const [searchParams] = useSearchParams();

  return {
    interviewId: searchParams.get('interviewId'),
    candidateId: searchParams.get('candidateId'),
    token: searchParams.get('token'),
  };
};
